<div
  *ngIf="terminalList?.length > 1"
  style="margin-top: 25px"
  class="form-data__row"
>
  <div
    class="form-group input-float-label"
    [class.select-disabled]="disabledStart"
  >
    <ng-select
      [formControl]="terminalIdInControl"
      id="reservation-terminal-in"
      placeholder="{{ 'common.terminalIn' | translate }}"
      controlErrorsClass="info-field"
      [clearable]="false"
      [searchable]="false"
    >
      <ng-option *ngFor="let terminal of terminalList" [value]="terminal.id">{{
        terminal.name_short
      }}</ng-option>
    </ng-select>
    <label for="costCenterId" class="float-label">{{
      'common.terminalIn' | translate
    }}</label>
  </div>
  <div class="form-group input-float-label">
    <ng-select
      [formControl]="terminalIdOutControl"
      id="reservation-terminal-out"
      placeholder="{{ 'common.terminalOut' | translate }}"
      controlErrorsClass="info-field"
      [clearable]="false"
      [searchable]="false"
    >
      <ng-option *ngFor="let terminal of terminalList" [value]="terminal.id">{{
        terminal.name_short
      }}</ng-option>
    </ng-select>
    <label for="costCenterId" class="float-label">{{
      'common.terminalOut' | translate
    }}</label>
  </div>
</div>
